import { common } from './common'
import { contentType } from './content-type'

export let components = {
	contentType,
	common
}



// WEBPACK FOOTER //
// ./src/vue/components/index.js